import React, { Component } from 'react';
import './home.css';
import axios from 'axios';

import 'bootstrap/dist/css/bootstrap.min.css';
import * as CONSTS from './consts.js';

import {  deleteFromProducts, stringToList, readSessionValue, storeSessionValue } from './helper.js';
import { BestProductsCard, AllProductsCard, PremiumProductCard } from './components.js'

class Home extends Component {
  constructor() {
    super();
    this.state= {
      liters: '1000',
      litersToShow: '1000',
      postcodeFound: false,
      postcode: '',
      searchHistoryExists: false,
      summerWinter: "",
      typeUse: "lammityskaytto",
      loadingData : true,
      businessCustomer : false,
      priceListSummer: [],
      priceListWinter: [],
      bestPrices: {},

    };
    this.rawPriceData = {};

  }

async componentDidMount() {
  document.title = 'PÖ.fi | Koti';
  if (readSessionValue('priceData') == null || readSessionValue('priceData') == "{}") {

        this.changeSummerWinter({target: {value: 'summer'}});
        this.changeTypeUse({target: {value: 'lammityskaytto'}});
        //this.setState({postcode: ''}, () => {
          this.changeBusinessCustomer({target: {checked: false} });
        //})
        this.setState({loadingData: false});

        storeSessionValue('priceData', JSON.stringify(this.rawPriceData))
        storeSessionValue('currType', 'summer');
        storeSessionValue('currLiters', '1000');

  } else {
    this.rawPriceData = JSON.parse(readSessionValue('priceData'));

    this.changeSummerWinter({target: {value: readSessionValue('currType')}});
    this.changeTypeUse({target: {value: readSessionValue('currTypeUse')}});
    let busCust = readSessionValue('currBusCust') === 'true' ? true : false;
    this.setState({businessCustomer: busCust});
    this.changeLiterValue({target: {value: readSessionValue('currLiters')}});
    this.searchPricesFromSessionStorage(readSessionValue('currPostcode'), JSON.parse(readSessionValue('priceData')), readSessionValue('currType'));
    this.setState({loadingData: false});
  }

  }

  changeLiterValue = (e) => {
    const re = /^[0-9\b]+$/;
    if (e.target.value === '' || re.test(e.target.value)){

    this.setState({liters : e.target.value});

    if (e.target.value[0] === '0' && e.target.value.length > 1) {
      this.setState({liters: 1000});
    }

    if (e.target.value > 10000) {
      this.setState({liters : 10000});
      this.setState({litersToShow : 10000}, function () {storeSessionValue('currLiters', this.state.litersToShow)});

    }

    else if ((e.target.value.length === 4 || e.target.value.length === 5)) {

      this.setState({liters : Math.round(e.target.value / 100)*100})
      this.setState({litersToShow : Math.round(e.target.value / 100)*100}, function () {storeSessionValue('currLiters', this.state.litersToShow)});


    }

  }

  }

  changeTypeUse = (e) => {
    this.setState({typeUse: e.target.value},
      function() {storeSessionValue('currTypeUse', this.state.typeUse)})
  }

  changeSummerWinter = (e) => {
    this.setState({summerWinter:e.target.value},
      function() {storeSessionValue('currType', this.state.summerWinter)})
  }

  changeBusinessCustomer = (e) => {

    this.setState({businessCustomer: e.target.checked},
      () => {this.updatePostcode({target: {value:this.state.postcode}}); storeSessionValue('currBusCust', this.state.businessCustomer)});
  }

  updatePostcode = (e) => {
    this.setState({postcode: e.target.value})


    const performanceData = {postcode: e.target.value, businessCustomer: this.state.businessCustomer}

    let postcodeFound;
    if (e.target.value.length === 5) {
      this.setState({searchHistoryExists: true})
      this.setState({loadingData: true}, () => {


      axios.post(`${CONSTS.API_URL}/get-prices-performance`, performanceData)
      .then (res => {

        const priceData = JSON.parse(res.data);

        let prices = {};

        for (let combination in priceData) {
          if (priceData.hasOwnProperty(combination)) {
            prices[priceData[combination].provider + ' ' + priceData[combination].provider_type
             + ' ' + priceData[combination].type] = { 'extra_info' : priceData[combination].extra_info,
            'combination_id' : priceData[combination].combination_id, 'type_use' : priceData[combination].type_use,
             'premium' : priceData[combination].premium};



            prices[priceData[combination].provider + ' ' + priceData[combination].provider_type + ' '
            + priceData[combination].type]['prices_per_liter'] = priceData[combination].prices;

          }
        }


        let priceListSummer = [],
          priceListWinter = [];
        for (let provider in prices) {
          if (prices.hasOwnProperty(provider)) {

            if (provider.toLowerCase().includes('summer') || provider.toLowerCase().includes('kesä')) {
              priceListSummer.push([provider, prices[provider]]);

          }
          if (provider.toLowerCase().includes('winter') || provider.toLowerCase().includes('talvi')) {
            priceListWinter.push([provider, prices[provider]]);

          }

          }
        }


        priceListSummer.sort((a,b) => {return a[1].prices_per_liter[this.state.litersToShow]-b[1].prices_per_liter[this.state.litersToShow]});
        priceListWinter.sort((a,b) => {return a[1].prices_per_liter[this.state.litersToShow]-b[1].prices_per_liter[this.state.litersToShow]});
        this.setState({priceListSummer: priceListSummer}, function() {
          storeSessionValue('currPostcode', this.state.postcode);
      });
        this.setState({priceListWinter: priceListWinter}, function() {storeSessionValue('currPostcode', this.state.postcode)});


        if (Object.entries(prices).length === 0 && prices.constructor === Object) {
          this.setState({postcodeFound: false})
          this.setState({searchHistoryExists: true})
        } else {
          this.setState({postcodeFound: true})
          this.setState({searchHistoryExists: true})
        }
        this.rawPriceData = priceData

        storeSessionValue('priceData', JSON.stringify(this.rawPriceData))
        this.setState({loadingData: false})
        postcodeFound = true;


    }).catch((res) => {
      this.setState({loadingData: false});
        postcodeFound = false;

      }).finally(() =>{
        this.setState({postcodeFound: postcodeFound});
      });

});
  }

}

  searchPricesFromSessionStorage = (postcode, priceData, summerWinter) => {
    this.setState({postcode: postcode}, () => {
      this.setState({summerWinter: summerWinter}, () => {
        if (postcode.length === 5) {
          if (this.state.searchHistoryExists === false) {
            this.setState({searchHistoryExists: true})
          }
          let prices = {};
          for (let combination in priceData) {
            if (priceData.hasOwnProperty(combination)) {
              prices[priceData[combination].provider
              + ' ' + priceData[combination].provider_type + ' ' + priceData[combination].type] = {'extra_info' : priceData[combination].extra_info,
              'combination_id' : priceData[combination].combination_id, 'type_use' : priceData[combination].type_use,
               'premium' : priceData[combination].premium};
              prices[priceData[combination].provider + ' ' + priceData[combination].provider_type + ' '
              + priceData[combination].type]['prices_per_liter'] = priceData[combination].prices

            }
          }


          let priceListSummer = [],
            priceListWinter = [];
          for (let provider in prices) {
            if (prices.hasOwnProperty(provider)) {

              if (provider.toLowerCase().includes('summer') || provider.toLowerCase().includes('kesä')) {
                priceListSummer.push([provider, prices[provider]]);

            }
            if (provider.toLowerCase().includes('winter') || provider.toLowerCase().includes('talvi')) {
              priceListWinter.push([provider, prices[provider]]);

            }

            }
          }

          priceListSummer.sort((a,b) => {return a[1].prices_per_liter[this.state.litersToShow]-b[1].prices_per_liter[this.state.litersToShow]});
          priceListWinter.sort((a,b) => {return a[1].prices_per_liter[this.state.litersToShow]-b[1].prices_per_liter[this.state.litersToShow]});

          this.setState({priceListSummer: priceListSummer}, function() {
            storeSessionValue('currPostcode', this.state.postcode);
        });
          this.setState({priceListWinter: priceListWinter}, function() {storeSessionValue('currPostcode', this.state.postcode)});


          if (Object.entries(prices).length === 0 && prices.constructor === Object) {
            this.setState({postcodeFound: false})

          } else {
            this.setState({postcodeFound: true})

          }


        }
      });
    });



  }



  render() {
    const postcodeFound = this.state.postcodeFound;
    const searchHistoryExists = this.state.searchHistoryExists;
    let suggestedProducts;
    let allProducts;
    let premiumProducts;
    let currentPriceList;
    let currentPriceListFull;
    let imageNames = [['teboil', 'Teboil-logo.svg'], ['neste', 'Neste-logo.svg'], ['st1', 'St1-logo.svg']];


    // Always on render let's rearrange prices so they swap around as you change the liter amount

    if (postcodeFound) {
      if (this.state.summerWinter === 'summer' || this.state.summerWinter === 'kesä') {
        currentPriceListFull = this.state.priceListSummer.sort((a,b) => {return a[1].prices_per_liter[this.state.litersToShow]-b[1].prices_per_liter[this.state.litersToShow]});;
      } else if (this.state.summerWinter === 'winter' || this.state.summerWinter === 'talvi') {
        currentPriceListFull = this.state.priceListWinter.sort((a,b) => {return a[1].prices_per_liter[this.state.litersToShow]-b[1].prices_per_liter[this.state.litersToShow]});;
      }
      currentPriceList = deleteFromProducts(currentPriceListFull, this.state.typeUse);
    try {
    let currBestProductInfo = stringToList(currentPriceList[0][1].extra_info, ','),
        currSecondBestProductInfo = stringToList(currentPriceList[1][1].extra_info, ','),
        currThirdBestProductInfo = stringToList(currentPriceList[2][1].extra_info, ',');

    let bestProductInfo = [],
        secondBestProductInfo = [],
        thirdBestProductInfo = [];

    for (let i = 1; i < currBestProductInfo.length+1; i++) {
      bestProductInfo.push(<li key={'0'+i.toString() +'-top-products-'+this.state.summerWinter}>{currBestProductInfo[i-1]}</li>);
    }
    for (let i = 1; i < currSecondBestProductInfo.length+1; i++) {
      secondBestProductInfo.push(<li key={'1'+i.toString() +'-top-products-'+this.state.summerWinter}>{currSecondBestProductInfo[i-1]}</li>);
    }
    for (let i = 1; i < currThirdBestProductInfo.length+1; i++) {
      thirdBestProductInfo.push(<li key={'2'+i.toString() +'-top-products-'+this.state.summerWinter}>{currThirdBestProductInfo[i-1]}</li>);
    }




      suggestedProducts = (
        <section className="suggested-products-container row">
        <div className="col-sm-12">

          <BestProductsCard typeUse={this.state.typeUse} businessCustomer={this.state.businessCustomer}
          loadingData={this.state.loadingData}
          postcode={this.state.postcode} combId={currentPriceList[1][1].combination_id}
          id="second-cheapest-product" price={currentPriceList[1][1].prices_per_liter[this.state.litersToShow]}
          productInfo={secondBestProductInfo} providerName={currentPriceList[1][0]} imageNames={imageNames}
          liters={this.state.litersToShow} cheapest={false}/>

          <BestProductsCard typeUse={this.state.typeUse} businessCustomer={this.state.businessCustomer}
          loadingData={this.state.loadingData}
          postcode={this.state.postcode} combId={currentPriceList[0][1].combination_id}
          id="cheapest-product"
          price={currentPriceList[0][1].prices_per_liter[this.state.litersToShow]} productInfo={bestProductInfo}
          providerName={currentPriceList[0][0]}
          worstProduct={currentPriceList[currentPriceList.length-1][1].prices_per_liter[this.state.litersToShow]}
          imageNames={imageNames} liters={this.state.litersToShow} cheapest={true}/>

          <BestProductsCard typeUse={this.state.typeUse} businessCustomer={this.state.businessCustomer}
          loadingData={this.state.loadingData}
          postcode={this.state.postcode} combId={currentPriceList[2][1].combination_id}
          id="third-cheapest-product"
          price={currentPriceList[2][1].prices_per_liter[this.state.litersToShow]} productInfo={thirdBestProductInfo}
          providerName={currentPriceList[2][0]} imageNames={imageNames} liters={this.state.litersToShow} cheapest={false}/>


        </div>

        </section>
      );
    } catch(e) {

    }
      let allProductsHTML = [];
      let premiumProductsHTML = [];
      let o = 3;
      for (let i = 0; i < currentPriceList.length; i++) {

          let productInfos = [];
          let currInfoList = stringToList(currentPriceList[i][1].extra_info, ',');
          for (let j = 0; j < currInfoList.length; j++){
            productInfos.push(<li key={o.toString() +(j+1).toString() +'-all-products-'+this.state.summerWinter}>{currInfoList[j]}</li>)

          }

          o++;
          if (currentPriceList[i][1].premium) {
            premiumProductsHTML.push(
              <PremiumProductCard loadingData={this.state.loadingData}
              combId={currentPriceList[i][1].combination_id} postcode={this.state.postcode} id={i.toString() + '-all-products-card'}
              businessCustomer={this.state.businessCustomer} typeUse={this.state.typeUse}
              productInfos={productInfos}  providerName={currentPriceList[i][0]}
              price={currentPriceList[i][1].prices_per_liter[this.state.litersToShow]} liters={this.state.litersToShow}
              imageNames={imageNames}/>
            )
          } else {
          allProductsHTML.push(
            <AllProductsCard loadingData={this.state.loadingData}
            combId={currentPriceList[i][1].combination_id} postcode={this.state.postcode} id={i.toString() + '-all-products-card'}
            businessCustomer={this.state.businessCustomer} typeUse={this.state.typeUse}
            productInfos={productInfos}  providerName={currentPriceList[i][0]}
            price={currentPriceList[i][1].prices_per_liter[this.state.litersToShow]} liters={this.state.litersToShow}
            imageNames={imageNames}/>
            );
        }
      }





      allProducts = (
        <section className="all-products">
        <h3>Koko valikoimamme</h3>
        <div className="all-products-list-container">
          {premiumProductsHTML}
          {allProductsHTML}
          </div>
        </section>
      );
    } else if (!searchHistoryExists){
      if (this.state.loadingData) {
        suggestedProducts = (
          <section className="Suggested-products-container">
          <h2 className="white-text">Ladataan</h2>
          </section>
        );
      } else {
      suggestedProducts = (
        <section className="Suggested-products-container">

        </section>
      );
    }
      allProducts = (

          <section className="All-products">

          </section>

      );
    } else if (searchHistoryExists && !postcodeFound){
      if (this.state.loadingData) {
        suggestedProducts = (
          <section className="Suggested-products-container">
          <h2 className="white-text">Ladataan</h2>
          </section>
        );
      } else {
      suggestedProducts = (
        <section className="Suggested-products-container">
        <h2 className="white-text">Valitsemallasi postinumerolla ei löydy tuloksia</h2>
        </section>
      );
    }
      allProducts = (

          <section className="All-products">

          </section>

      );
    }

    return (
      <div className="home-wrapper">
      <div className="body-container home-page">

        <header>
          <h1 className="white-text">Vertaile ja tilaa polttoöljyä</h1>
          <h3 className="white-text">Aina edulliseen päivän hintaan!</h3>
         </header>
         <div className="row top-buffer"></div>
         <section className="Main-section">
         <div className="row">
         <div className="col-sm-12">
          <span className="block-span white-text">Aloita valitsemalla postinumerosi</span>
          </div>
          </div>
          <div className="row top-buffer-small"></div>
          <div className="row">
          <div className="col-sm-12">
          <input className="postcode-input data-hj-whitelist" placeholder="Syötä postinumero (esim. 21200)" type="text" value={this.state.postcode} name="postcode"  onChange={this.updatePostcode} />
          </div>
          </div>
          <div className="row top-buffer-small"></div>
          <div className="row">
          <div className="col-sm-12">
          <input type="radio" id="summer" className="summer-winter" name="summer-winter" value="summer" onChange={this.changeSummerWinter}
          checked={this.state.summerWinter === "summer"}/>
          <label className="radio-label-left radio-label" htmlFor="summer">Kesälaatu</label>
          <input type="radio" id="winter" className="summer-winter" name="summer-winter" value="winter" onChange={this.changeSummerWinter}
          checked={this.state.summerWinter === "winter"}/>
          <label className="radio-label-right radio-label" htmlFor="winter">Talvilaatu</label>
          </div>
          <div className="col-sm-12">
          <div className="type-container">
            <div className="type-row">
            <input type="radio" id="lammityskaytto" name="type-use" value="lammityskaytto" onChange={this.changeTypeUse}
            checked={this.state.typeUse === "lammityskaytto"}/>
            <label className="custom-radio-label custom-radio-left" htmlFor="lammityskaytto">Lämmityskäyttöön</label>
            </div>
            <div className="type-row">
            <input type="radio" id="moottorikaytto" name="type-use" value="moottorikaytto" onChange={this.changeTypeUse}
            checked={this.state.typeUse === "moottorikaytto"}/>
            <label className="custom-radio-label custom-radio-right" htmlFor="moottorikaytto">Moottorikäyttöön</label>
            </div>
          </div>
          </div>
          </div>

          <div className="row top-buffer-small"></div>
          <div className="row slider-row">
          <div className="col-sm-12">
          <div className="min-block-in-slider">
          <div id="slider-row-min-block" className="white-text">min. <br />1000 L </div>
          </div>
          <input type="range" name="gas" min="1000" max="10000" step="100" className="liter-slider" value={this.state.liters} onChange={this.changeLiterValue}/>
          <div className="liter-amount-in-slider">
          <input type="text" name="gas-text" className="liter-input" value={this.state.liters} onChange={this.changeLiterValue} />
          <div id="slider-row-liter-text-block"><span>litraa</span></div>
          </div>
          </div>
          </div>
          <div className="row top-buffer-small"></div>
          <div className="row">
          <div className="col-sm-12">

            <input type="checkbox" id="business-customer" disabled={this.state.loadingData} name="business-customer" checked={this.state.businessCustomer} onChange={this.changeBusinessCustomer} />
              <label htmlFor="business-customer">
                <svg viewBox="0,0,50,50">
                  <path d="M5 30 L 20 45 L 45 5"></path>
                </svg>
              </label>
              <span className="custom-checkbox-span-label"><b>Olen yritysasiakas</b> (sis. alv 24%)</span>



          </div>
          </div>

          <div className="row top-buffer"></div>
          { suggestedProducts }
          <div className="gray-background"></div>
          <div className="row top-buffer"></div>

          { allProducts }

         </section>
      </div>
      </div>
    );

}
}

export default Home;
